export const COMPONENT_NAME = "shared-switch";
